import has from 'has';

var allowedPolicyTypes = {
    names: []
};

if (has('endorsement-products.Homeowners') || has('endorsement-products.HOPHomeowners')) {
    allowedPolicyTypes.names.push('Homeowners', 'homeowners', 'HomeownersLine_HOE', 'HOPHomeowners');
}
if (has('endorsement-products.PersonalAuto')) {
    allowedPolicyTypes.names.push('PersonalAuto', 'personalAuto', 'auto_per');
}

export default allowedPolicyTypes;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/endorsement/AllowedPolicyTypes.js
// module id = 2204
// module chunks = 0